<template>
	<div>
		<el-table stripe @row-click="selectedArticle" :data="tableData" style="width:75rem;margin: 0 auto;">
			<el-table-column prop="title" label="新闻标题" width="350">
				<template  slot-scope="scope">
					<div style="font-weight: bold;display: inline-block;
  white-space: nowrap; 
  width: 20rem;
  overflow: hidden;
  text-overflow:ellipsis;">
						{{scope.row.title}}
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="sketch" label="新闻内容" width="500">
				<template slot-scope="scope">
					<div style=" display: inline-block;
  white-space: nowrap; 
  width: 23.75rem;
  overflow: hidden;
  text-overflow:ellipsis;">{{scope.row.sketch}}</div>
				</template>
			</el-table-column>
			<!-- <el-table-column prop="releaseunit" label="发布单位">
			</el-table-column> -->
			<el-table-column prop="ReleaseDate" label="发布时间">
				<template slot-scope="scope">
					<div>{{scope.row.ReleaseDate.substr(0,10)}}</div>
				</template>
			</el-table-column>
		</el-table>
		<div class="block" style="display: flex;justify-content: center;padding: 1rem 0;">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="1"
				:page-sizes="[10,20,50,100]" :page-size="10" layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</div>
	</div>
</template>
<script>
	import {
		scrollAnimation
	} from '../../../utils/js/scrollAnimation.js';
	import {
		newsList
	} from '../../../common/api.js'
	export default {
		data() {
			return {
				newsList,
				tableData: [],
				pageSize: 10,
				pageNum: 1,
				total: 0,
			}
		},
		created() {
			// document.documentElement.scrollTop=800;
			this.getNewsList('', this.pageNum, this.pageSize)
			const currentY = document.documentElement.scrollTop || document.body.scrollTop
			if (currentY == 0) return;
			scrollAnimation(currentY, 800)
		},
		methods: {

			selectedArticle(row, column, event) {
				console.log(row)
				console.log(column)
				console.log(event)
				this.$router.push({
					path: '/news/newsDetail',
					query: {
						id: row.Id
					}
				})
				console.log(res)
			},
			async getNewsList(type, pageNum, pageSize) {
				var res = await this.newsList({
					type,
					PageIndex: pageNum,
					PageSize: pageSize
				})
				this.tableData = res.data.Data
				this.total = res.data.Total
			},
			async handleSizeChange(i) {
				this.pageSize = i
				this.getNewsList('', this.pageNum, this.pageSize)
			},
			handleCurrentChange(i) {
				this.pageNum = i
				this.getNewsList('', this.pageNum, this.pageSize)
			}
		}
	}
</script>

<style>
	.cell {
		font-size: 0.875rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #333333;
		text-align: center;
		padding: 1.1rem 0;
	}

	.el-table__row {
		/* background-color: #F1F6FF !important; */
		cursor: pointer;
	}

	.el-table__row--striped td.el-table__cell {
		background-color: #F1F6FF !important;
	}

	.has-gutter th {
		background-color: #2A68F9 !important;
	}

	.has-gutter .cell {
		font-size: 1rem;
		font-family: PingFang-SC-Bold, PingFang-SC;
		font-weight: bold;
		color: #FFFFFF;
	}
</style>
